// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/app/src/models/department';
import model_2 from '/app/src/models/globalRouter';
import model_3 from '/app/src/models/wxUser';
import model_4 from '/app/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'department', model: model_1 },
model_2: { namespace: 'globalRouter', model: model_2 },
model_3: { namespace: 'wxUser', model: model_3 },
model_4: { namespace: '@@initialState', model: model_4 },
} as const
